"use strict";
// Copyright 2020-2022 SubQuery Pte Ltd authors & contributors
// SPDX-License-Identifier: Apache-2.0
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GraphqlQueryClient = void 0;
const core_1 = require("@apollo/client/core");
const cross_fetch_1 = __importDefault(require("cross-fetch"));
const network_query_1 = require("@subql/network-query");
const network_config_1 = require("@subql/network-config");
const apollo_1 = require("../utils/apollo");
class GraphqlQueryClient {
    constructor(config) {
        this.config = config;
        this.apolloClients = {};
        this.apolloClients[network_config_1.GQLEndpoint.Network] = new core_1.ApolloClient({
            cache: new core_1.InMemoryCache({ resultCaching: true }),
            link: new core_1.HttpLink({ uri: config.gql.network, fetch: cross_fetch_1.default }),
            defaultOptions: {
                watchQuery: {
                    fetchPolicy: 'no-cache',
                },
                query: {
                    fetchPolicy: 'no-cache',
                },
            },
        });
    }
    get networkClient() {
        return this.apolloClients[network_config_1.GQLEndpoint.Network];
    }
    // QUERY REGISTRY QUERY FUNCTIONS
    async getIndexer(address) {
        const result = await (0, apollo_1.wrapApolloResult)(this.networkClient.query({
            query: network_query_1.GetIndexer,
            variables: { address },
        }));
        return result === null || result === void 0 ? void 0 : result.indexer;
    }
    async getDelegation(indexer, delegator) {
        const result = await (0, apollo_1.wrapApolloResult)(this.networkClient.query({
            query: network_query_1.GetDelegation,
            variables: { id: `${indexer}:${delegator}` },
        }));
        return result === null || result === void 0 ? void 0 : result.delegation;
    }
    async getDelegator(delegator) {
        const result = await (0, apollo_1.wrapApolloResult)(this.networkClient.query({
            query: network_query_1.GetDelegator,
            variables: { address: delegator },
        }));
        return result === null || result === void 0 ? void 0 : result.delegator;
    }
    async getTotalLock() {
        const result = await (0, apollo_1.wrapApolloResult)(this.networkClient.query({
            query: network_query_1.GetTotalLock,
        }));
        return result === null || result === void 0 ? void 0 : result.totalLocks;
    }
}
exports.GraphqlQueryClient = GraphqlQueryClient;
//# sourceMappingURL=queryClient.js.map